import { Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../context/AppContext.js";
import useHttp from "../../../hooks/useHttp";
import { useVoiceContext } from "../../context/VoiceContext.js";
import { handleStatusChange, voiceAgentMode, voiceAgentStatus } from "../../utils/VoiceUtils.js";
import { useVoiceAgentStatus } from "../../hooks/useVoiceAgentStatus.jsx";
const AgentStatusSelect = (props) => {
  let { classNameProps, expandIcon, restrictAccess, setShowOfflineMessageWhileInit, isFromHeader } = props;
  const { fetchData } = useHttp();
  const [appProperties] = useContext(AppContext);
  const [voiceIntegId, setVoiceIntegId] = useState();
  const [callProperties, setCallProperties] = useVoiceContext();
  const [statusOptions, setStatusOptions] = useState([]);
  const { getCallerInfoDetails } = useVoiceAgentStatus();
  let leftServiceId = appProperties?.leftServiceId;

  const webStatus = {
    value: 1,
    label: (
      <div className={`p-1 ${isFromHeader ? "" : "hs-color-white"}`}>
        <span className="onlineIndicatorDot"></span>
        <span className="ps-2">Online</span>
      </div>
    ),
  };

  const phoneStatus = {
    value: 2,
    label: (
      <div className={`p-1 ${isFromHeader ? "" : "hs-color-white"}`}>
        <span className="onlineIndicatorDot"></span>
        <span className="ps-2">Online</span>
      </div>
    ),
  };

  const busyStatus = {
    value: 5,
    label: (
      <div className={`p-1 ${isFromHeader ? "" : "hs-color-white"}`}>
        <span className="busyIndicatorDot"></span>
        <span className="ps-2">Busy</span>
      </div>
    ),
  };

  const offlineStatus = {
    value: 6,
    label: (
      <div className={`p-1 ${isFromHeader ? "" : "hs-color-white"}`}>
        <span className="offlineIndicatorDot"></span>
        <span className="ps-2">Offline</span>
      </div>
    ),
  };
  const remainingStatuses = [busyStatus, offlineStatus];

  const handleAgentStatusChange = (value) => {
    handleStatusChange(
      value,
      callProperties?.agentVoiceMode,
      leftServiceId,
      appProperties,
      voiceIntegId,
      fetchData,
      setCallProperties,
      setShowOfflineMessageWhileInit
    );
  };

  useEffect(() => {
    if (appProperties?.installedApps) {
      const voiceIntegrations = appProperties?.installedApps?.filter((integration) => integration.right.serviceType === "VOICE");
      if (voiceIntegrations?.[0]?.integProps?.integId) {
        setVoiceIntegId(voiceIntegrations?.[0]?.integProps?.integId);
      }
    }
  }, [appProperties?.installedApps]);

  useEffect(() => {
    if (callProperties?.agentVoiceMode) {
      if (callProperties?.agentVoiceMode === voiceAgentMode.OVER_THE_WEB) {
        setStatusOptions([webStatus, ...remainingStatuses]);
      } else if (callProperties?.agentVoiceMode === voiceAgentMode.OVER_THE_PHONE) {
        setStatusOptions([phoneStatus, ...remainingStatuses]);
      } else {
        setStatusOptions([...remainingStatuses]);
      }
    } else {
      getCallerInfoDetails(appProperties?.currentUser?.osyncUserId).then((response) => {
        const agentVoiceMode = response?.agentStatus?.voiceAgentMode;
        setCallProperties((prev) => ({
          ...prev,
          agentVoiceMode: agentVoiceMode,
        }));
        if (agentVoiceMode === voiceAgentMode.OVER_THE_WEB) {
          console.log("DEBUG>>>agentVoiceMode>>>>>", agentVoiceMode);
          setStatusOptions([webStatus, ...remainingStatuses]);
        } else if (agentVoiceMode === voiceAgentMode.OVER_THE_PHONE) {
          console.log("DEBUG>>>agentVoiceMode>>>>>", agentVoiceMode);
          setStatusOptions([phoneStatus, ...remainingStatuses]);
        } else {
          setStatusOptions([...remainingStatuses]);
        }
      });
    }
  }, [callProperties?.agentVoiceMode, appProperties?.currentUser?.osyncUserId]);

  return (
    <div>
      {" "}
      {console.log("callProperties?.agentStatusValue ikjikjikji ", callProperties?.agentStatusValue)}
      {console.log("callProperties?.agentVoiceMode ikjikjikji ", callProperties?.agentVoiceMode)}
      <div className={`${classNameProps} `}>
        <Select
          defaultValue={callProperties?.agentStatusValue !== undefined ? callProperties?.agentStatusValue : voiceAgentStatus.OFFLINE}
          value={callProperties?.agentStatusValue}
          popupClassName={isFromHeader ? "dialpadSelectList-header" : "dialpadSelectList"}
          rootClassName={`cursor-pointer ${isFromHeader ? "dialpadSelectList-header" : "dialpadSelectList"}`}
          suffixIcon={<div className={`${expandIcon} call-action-icons `} />}
          options={statusOptions}
          disabled={callProperties?.disableAgentStatusChange || restrictAccess}
          onChange={handleAgentStatusChange}
        />
      </div>
    </div>
  );
};

export default AgentStatusSelect;
